export default __webpack_public_path__ + "static/media/aes-light.68bc4098.svg";